import { memoize, mapKeys } from 'lodash';
import screens from '../api/screens';
import ensembl from '../api/ensembl';
import ncbi from '../api/ncbi';
import {
  CURRENT_ROUTE,
  AJAX_START,
  AJAX_END,
  FETCH_SCREENS,
  SET_NAME_SELECTED_SCREEN,
  FETCH_SCREEN_DATA,
  SELECTED_GENE,
  UNSELECTED_GENE,
  SHOW_GENE_PROFILES,
  FETCH_GENE_PROFILE,
  CLEAR_STATE,
  MANY_SELECTED_GENES,
  MANY_UNSELECTED_GENES,
  COMPARE_WITH,
  GET_COMPARED_DATA,
  REMOVE_COMPARED_DATA,
  FETCH_UNIQ_SCORE,
  SET_COLOR_FISHTAIL,
  SET_SIG_THRESHOLD,
  SHOW_SIG_ONLY,
  GET_EXPRESSION_DATA,
  SET_UNIQ_SCORE_UNIVERSE,
  SET_UNIQ_SCORE_VIZ,
  DOWNLOAD_DATASET_SCREEN,
  FETCH_PUBLIC_MAP_DESCR,
  REMOVE_GENE_PROFILES,
  SET_SELECTED_GENE,
  FETCH_GENE_INFO_ENSEMBL,
  REMOVE_GENE_INFO_ENSEMBL,
  GET_ESSENTIAL_GENES,
  GET_SET_OPERATION,
  CLEAR_SET_OPERATION,
  UPDATE_SET_OPERATION,
  SET_UNIQ_THR_SET_OPERATION,
} from './types';

// const token = localStorage.getItem('token')

export const ajaxCallInit = () => {
  return { type: AJAX_START };
};

export const ajaxCallEnd = () => {
  return { type: AJAX_END };
};

export const setCurrentRoute = (route) => {
  return { type: CURRENT_ROUTE, payload: route };
};

export const FetchPublicMapDescr = () => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get('/api/screens/public/description', {
      headers: { Authorization: `Token ${token}` },
    });
    dispatch({ type: FETCH_PUBLIC_MAP_DESCR, payload: response.data });
  };
};

export const DownloadDatasetScreen = (
  pk,
  filename,
  sig_thr,
  include_public,
  include_scenic,
  universe
) => {
  return async () => {
    const token = localStorage.getItem('token');
    const response = await screens.get(
      `/api/screens/${pk}/download?sig_thr=${sig_thr}&includePublic=${include_public}&includeScenic=${include_scenic}&toCompare=${universe}`,
      { headers: { Authorization: `Token ${token}` } }
    );

    var blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
  };
};

export const getScreens = () => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get('/api/screens/', {
      headers: { Authorization: `Token ${token}` },
    });

    dispatch({ type: FETCH_SCREENS, payload: response.data });
  };
};

export const setNameSelectedScreen = (value) => {
  return { type: SET_NAME_SELECTED_SCREEN, payload: value };
};

export const getScreenData = (pk) => {
  return async (dispatch) => {
    dispatch(ajaxCallInit());
    const token = localStorage.getItem('token');
    const response = await screens.get(`api/screens/${pk}/data`, {
      headers: { Authorization: `Token ${token}` },
    });

    dispatch({ type: FETCH_SCREEN_DATA, payload: response.data });
    dispatch(ajaxCallEnd());
  };
};

export const getUniqScore = (
  pk,
  sig_thr,
  include_public,
  include_scenic,
  universe
) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get(
      `api/screens/uniqscore?sig_thr=${sig_thr}&includePublic=${include_public}&includeScenic=${include_scenic}&toCompare=${universe}`,
      { headers: { Authorization: `Token ${token}` } }
    );

    dispatch({ type: FETCH_UNIQ_SCORE, payload: response.data });
  };
};

export const getExpressionData = () => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get(`api/screens/expression`, {
      headers: { Authorization: `Token ${token}` },
    });

    dispatch({ type: GET_EXPRESSION_DATA, payload: response.data });
  };
};

export const setUniqScoreUniverse = (obj) => {
  return { type: SET_UNIQ_SCORE_UNIVERSE, payload: obj };
};

export const setUniqScoreViz = (number) => {
  return { type: SET_UNIQ_SCORE_VIZ, payload: number };
};

export const setSigThreshold = (value) => {
  return { type: SET_SIG_THRESHOLD, payload: value };
};

export const showSigOnly = (value) => {
  return { type: SHOW_SIG_ONLY, payload: value };
};

export const addSelectedGene = (gene) => {
  return { type: SELECTED_GENE, payload: gene };
};

export const addManySelectedGenes = (gene_list) => {
  return { type: MANY_SELECTED_GENES, payload: gene_list };
};

export const removeSelectedGene = (gene) => {
  return { type: UNSELECTED_GENE, payload: gene };
};

export const removeManySelectedGenes = (gene_list) => {
  return { type: MANY_UNSELECTED_GENES, payload: gene_list };
};

export const showGeneProfiles = (bool) => {
  return { type: SHOW_GENE_PROFILES, payload: bool };
};

export const _getGeneProfile = memoize(async (gene_name, dispatch) => {
  const token = localStorage.getItem('token');
  const response = await screens.get(`api/screens/gene/${gene_name}`, {
    headers: { Authorization: `Token ${token}` },
  });
  dispatch({ type: FETCH_GENE_PROFILE, payload: response.data });
});

export const getGeneProfile = (gene_name) => {
  return (dispatch) => {
    _getGeneProfile(gene_name, dispatch);
  };
};

export const setColorPlot = (value) => {
  return { type: SET_COLOR_FISHTAIL, payload: value };
};

export const compareWithScreen = (bool) => {
  return { type: COMPARE_WITH, payload: bool };
};

export const getComparedData = (pk, pk_comp) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get(`api/screens/${pk}/compare/${pk_comp}`, {
      headers: { Authorization: `Token ${token}` },
    });

    dispatch({ type: GET_COMPARED_DATA, payload: response.data });
  };
};

export const removeCompareData = () => {
  return { type: REMOVE_COMPARED_DATA };
};

export const clearState = () => {
  return { type: CLEAR_STATE };
};

export const removeGeneProfiles = () => {
  return { type: REMOVE_GENE_PROFILES };
};

export const setSelectedGene = (gene_name) => {
  return { type: SET_SELECTED_GENE, payload: gene_name };
};

export const fetchGeneInfoEnsembl = (gene_name) => {
  return async (dispatch) => {
    try {
      const response_info = await ensembl.get(
        `lookup/symbol/homo/${gene_name}?content-type=application/json`
      );
      const response_entrezId = await ensembl.get(
        `xrefs/id/${response_info.data.id}?content-type=application/json`
      );
      const db_infos = mapKeys({ ...response_entrezId.data }, 'dbname');
      const entrez_id = db_infos.EntrezGene.primary_id;
      const ncbi_search = await ncbi.get(
        `esearch.fcgi?db=gene&term=${entrez_id}&usehistory=y&format=json&api_key=036868e471c40e1ebc89b64cfd38c6ec2709`
      );
      const { querykey, webenv } = ncbi_search.data.esearchresult;
      const ncbi_summary = await ncbi.get(
        `esummary.fcgi?db=gene&query_key=${querykey}&WebEnv=${webenv}&format=json&api_key=036868e471c40e1ebc89b64cfd38c6ec2709`
      );

      const selected_info = {
        symbol: gene_name,
        id: response_info.data.id,
        description: response_info.data.description,
        biotype: response_info.data.biotype,
      };
      // const selected_pheno = response_pheno.data;

      const {
        chromosome,
        maplocation,
        otheraliases,
        otherdesignations,
        summary,
        mim,
      } = ncbi_summary.data.result[entrez_id];

      dispatch({
        type: FETCH_GENE_INFO_ENSEMBL,
        payload: {
          ...selected_info,
          // pheno: selected_pheno,
          entrez: entrez_id,
          ...{
            chromosome,
            maplocation,
            otheraliases,
            otherdesignations,
            summary,
          },
          omim: mim[0],
        },
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: FETCH_GENE_INFO_ENSEMBL,
        payload: {
          error: 'gene info could not be found',
        },
      });
    }

    // const response_pheno = await ensembl.get(
    //   `phenotype/gene/homo/${gene_name}?content-type=application/json`
    // );
  };
};

export const removeGeneInfoEnsemble = () => {
  return { type: REMOVE_GENE_INFO_ENSEMBL };
};

export const getEssentialGenes = () => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    const response = await screens.get(`/api/essential/`, {
      headers: { Authorization: `Token ${token}` },
    });

    dispatch({ type: GET_ESSENTIAL_GENES, payload: response.data });
  };
};

export const getSetOperation = (intersect, exclude, sigThr, exclMode) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    dispatch(ajaxCallInit());
    const response = await screens.get(
      `api/screens/set_operation?intersect=${intersect}&exclude=${exclude}&sigThr=${sigThr}&exclMode=${exclMode}`,
      { headers: { Authorization: `Token ${token}` } }
    );
    dispatch(ajaxCallEnd());

    dispatch({ type: GET_SET_OPERATION, payload: response.data });
  };
};

export const clearSetOperation = () => {
  return { type: CLEAR_SET_OPERATION };
};

export const updateSetOperation = ({
  positive_regulators,
  negative_regulators,
}) => {
  return {
    type: UPDATE_SET_OPERATION,
    payload: { positive_regulators, negative_regulators },
  };
};

export const setUniqThrSetOperation = (value) => {
  return { type: SET_UNIQ_THR_SET_OPERATION, payload: value };
};
